<template>
  <div class="main-body">
    <div class="header">线上支付订单</div>
    <div class="out">

      <div class="search2">

        <el-button plain type="success" @click="settleOrder" size="mini">结算</el-button>


        <div style="float: right">

          <el-select v-model="governmentCode" placeholder="请选择政府"
                     clearable filterable
                     @change="govChange" style="margin-right:5px">
            <el-option
                v-for="item in governmentValue"
                :key="item.governmentCode"
                :label="item.name"
                :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-date-picker style="margin-right: 5px;width:210px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>

          <el-button size="mini" type="primary" plain @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                :summary-method="getSummaries" show-summary
                v-loading="loading" ref="table" border>

        <el-table-column prop="serialNumber" label="订单流水号" width="130" fixed></el-table-column>
        <el-table-column prop="businessName" label="商家" width="85"></el-table-column>
        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" label="单价" width="105">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsPrice}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price" label="总价" width="105"></el-table-column>

        <el-table-column width="105" label="订单来源" >
          <template slot-scope="scope">
            <div v-if="scope.row.orderFrom =='pc'">商家预工单</div>
            <div v-if="scope.row.orderFrom =='android' ">长者端</div>
            <div v-if="scope.row.orderFrom =='table' ">收银机</div>
          </template>
        </el-table-column>

        <el-table-column width="105" label="付款类型" >
          <template slot-scope="scope">
            <div v-if="scope.row.payType == 'wx' ">微信</div>
            <div v-if="scope.row.payType == 'ali' ">支付宝</div>
            <div v-if="scope.row.payType == 'yue' ">余额</div>
            <div v-if="scope.row.payType == 'cash' ">现金</div>
          </template>
        </el-table-column>
        <el-table-column width="105" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" width="105" label="删除">
          <template slot-scope="scope">
            <span v-if="scope.row.isDelete == 1">已删除</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="下单时间"></el-table-column>
        <el-table-column prop="planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>
        <el-table-column prop="payTime" :formatter="timefilter" width="200" label="付款时间"></el-table-column>
        <el-table-column prop="completeTime" :formatter="timefilter" width="200" label="完成时间"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data() {
    return {

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: this.$store.state.tableHeight,

      governmentValue: [],
      governmentCode: '',

      startEndTime:[],
      allPrice:'',

    }
  },
  components: {

  },
  created() {
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      const now = new Date();
      const start = new Date(now - 1000 * 60 * 60 * 24 * 30);
      const end = new Date(now);
      this.startEndTime = [timefilters(start).substring(0,10), timefilters(end).substring(0,10)];

      this.getGovList();
    },

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    govChange(val){
      this.governmentCode = val;
    },


    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },




    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true


      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        governmentCode: this.governmentCode,
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessAdm/PageOnlinePay",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.allPrice=response.data.data.allPrice;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },

    getSummaries(param) {

      //const { columns, data } = param;console.log(data);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = '合计';
        }

        if (index == 5) {
          sums[index] = parseFloat(this.allPrice).toFixed(2);
        }


        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //     sums[index] = values.reduce((prev, curr) => {
        //         const value = Number(curr);
        //         if (!isNaN(value)) {
        //             return prev + curr;
        //         } else {
        //             return prev;
        //         }
        //     }, 0);
        //     sums[index] += ' 元';
        // } else {
        //     sums[index] = 'N/A';
        // }



      });

      return sums;
    },

    settleOrder(){

      if(this.governmentCode==null || this.governmentCode==''){
        this.$message.info("请选择政府")
        return;
      }
      if(this.startEndTime[0]==null || this.startEndTime[0]==''){
        this.$message.info("请选择时间")
        return;
      }

      let govName = '';
      for(let i=0;i<this.governmentValue.length;i++){
        if(this.governmentCode == this.governmentValue[i].governmentCode){
          govName = this.governmentValue[i].name;
        }
      }

      const h = this.$createElement
      this.$confirm(
          h('div', [
            h('p', '确定生成结算？'),
            h('p', '政府：'+govName),
            h('p', '时间：'+this.startEndTime[0]+' 至 '+this.startEndTime[1]),
            h('p', '金额：'+this.allPrice),
          ]),
          '提示',
          {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.settleOrderDo();

      }).catch(() => {

      });
    },
    settleOrderDo(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "SettlementGovernment/AdmAdd",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode: this.governmentCode,
          startTime:this.startEndTime[0],
          endTime:this.startEndTime[1],
        }
      }).then((response) => {
        if (response.data.error == 0) {
          this.$message({type: 'success', message: '生成结算成功'});

          //go other page
          this.$router.push({ path:'/SettlementGovernment/AdmPage', query: { governmentCode:this.governmentCode }})

        } else if (response.data.error == 1) {
          this.$message({type: 'error', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>


<style lang="scss" scoped>

</style>
